import { motion } from "framer-motion";

const Reveal = ({ children }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
        >
            {children}
        </motion.div>
    );
};

export default Reveal;